var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "body",
    {
      staticClass: "app",
      class: { "no-scroll--mobile": _vm.navMenuOpen },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.handleEscPressed($event)
        }
      }
    },
    [
      _c("logo"),
      _c("top-navigation", { attrs: { ready: _vm.ready } }),
      _c(
        "transition",
        { attrs: { name: "left-nav" } },
        [_vm.ready ? _c("left-navigation") : _vm._e()],
        1
      ),
      _c(
        "div",
        { attrs: { id: "content" } },
        [
          _vm.ready ? _c("router-view") : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "scroll-to-top" } },
            [
              _c("vs-icon-button", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showScrollToTop,
                    expression: "showScrollToTop"
                  }
                ],
                staticClass: "scroll-to-top",
                attrs: { icon: "chevron-up" },
                on: { click: _vm.handleScrollToTop }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("vs-toaster", {
        attrs: { notifications: _vm.notifications },
        on: { "remove-toast": _vm.handleRemoveNotification }
      }),
      _c("portal-target", { attrs: { name: "body" } }),
      _c("login", { attrs: { ready: _vm.ready } }),
      _vm.isImpersonation ? _c("impersonation") : _vm._e(),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loginVisible,
            expression: "loginVisible"
          }
        ],
        attrs: { id: "google_recaptcha" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }